import React from "react";

const holder = {
  closeInputSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('isOpen', false);
      holder.tagsChanged && holder.outlet({ action: 'changeTags', payload: holder.tags });
      document.removeEventListener("mousedown", holder.closeInputSelector);
    }
  }
};

export default {
  'TagsInputCell.RelativeWrapper.Selector': async ({ isOpen, containerRef, inputRef, selectedTagIds, showCheckboxes }, outlet, internalStateSetter) => {
    if (isOpen || showCheckboxes) return;
    await internalStateSetter('isOpen', true);

    let newContainerRef = containerRef;
    let newInputRef = inputRef;

    if (!containerRef || !inputRef) {
      newContainerRef = React.createRef(null);
      newInputRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef, inputRef: newInputRef });
    }

    newInputRef?.current?.children?.[0]?.children?.[0]?.focus?.()

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;
    holder.tags = selectedTagIds;
    holder.outlet = outlet;
    holder.tagsChanged = false;

    document.addEventListener("mousedown", holder.closeInputSelector);
  },
  'TagsInputCell.RelativeWrapper.DropdownWrapper.Wrapper.BorderWrapper.ListWrapper.TagWrapper': ({ tag }, outlet, internalStateSetter) => {
    internalStateSetter({ selectedTagIds: [tag.id] });
    internalStateSetter('isOpen', false);
    outlet({ action: 'changeTags', payload: [tag.id] });
    document.removeEventListener("mousedown", holder.closeInputSelector);
  },
  'TagsInputCell.RelativeWrapper.DropdownWrapper.Wrapper.BorderWrapper.SearchWrapper.Wrapper.Close': ({ }, _, internalStateSetter) => {
    internalStateSetter({ selectedTagIds: [] })
    holder.tags = [];
    holder.tagsChanged = true;
  },
  'TagsInputCell.RelativeWrapper.DropdownWrapper.Wrapper.BorderWrapper.SearchWrapper.Wrapper.SearchInput': ({ value }, _, internalStateSetter) => {
    internalStateSetter({ searchVal: value })
  }
}